import { Link, Redirect } from "react-router-dom";
import Devider from "./Devider";
import SidebarNavigationItem from "./SidebarNavigationItem";
import { svg } from "../../../resources/Svg";
import { useAuth } from "../../../contexts/AuthContext";

const SidebarNavigation = ({ navigation }) => {
  const { signout } = useAuth();

  const handleLogout = async () => {
    try {
      await signout();
      <Redirect to="/SignIn" />;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <section
        ref={navigation}
        className="relative w-64 min-h-screen flex flex-col justify-between bg-gray-100"
      >
        <div className="w-full flex flex-col space-y-6 p-3">
          {/**LOGO*/}
          <div className="flex justify-center items-center">
            <Link to="/dashboard">
              <span className="sr-only">MPocket</span>
              <div className="flex items-center space-x-2 ">
                <img
                  className="h-8 w-auto sm:h-10"
                  src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
                  alt=""
                />
                <h1 className="text-2xl tracking-tight font-extrabold text-gray-700">
                  <span className="text-blue-700 font-black">M</span>Pocket
                </h1>
              </div>
            </Link>
          </div>

          {/**Tabs*/}
          {/**First Group*/}
          <div className="flex flex-col space-y-2 w-full ">
            <Link to="/dashboard">
              <SidebarNavigationItem svg={svg.dashboard} title={"Dashboard"} />
            </Link>
            <SidebarNavigationItem svg={svg.records} title={"Records"} />
            <SidebarNavigationItem svg={svg.reports} title={"Reports"} />
            <Devider />
            <Link to="/settings/general">
              <SidebarNavigationItem svg={svg.settings} title={"Settings"} />
            </Link>
            <SidebarNavigationItem svg={svg.help} title={"Help"} />
            <SidebarNavigationItem svg={svg.privacy} title={"Privacy"} />
          </div>
          <Devider />
          <div className="" onClick={() => handleLogout()}>
            <SidebarNavigationItem svg={svg.logout} title={"Logout"} />
          </div>
        </div>

        {/**Last Group*/}
      </section>
    </>
  );
};

export default SidebarNavigation;
